var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurstLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116,
    height: 55.167,
    viewBox: "0 0 116 55.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    className: "logo_svg",
    "data-name": "Group 8",
    transform: "translate(-124 -1150.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(29.8 1627.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M94.52-475.813c.187.76,2.12,8.814,4.307,17.907s3.947,16.561,3.933,16.587a14.349,14.349,0,0,1-1.52-1.32,9.6,9.6,0,0,0-1.547-1.293c-.093.093,2.053,8.747,2.68,10.8a15.128,15.128,0,0,0,11.6,10.84,17.45,17.45,0,0,0,6.333-.067,15.388,15.388,0,0,0,7.28-3.973,15.314,15.314,0,0,0,4.44-13.067,23.061,23.061,0,0,0-2.8-7.334c-1.093-1.867-8.04-9.414-14.413-15.654-5.693-5.574-6.107-5.96-6.027-5.627.347,1.427,1.333,5.907,1.293,5.907s-3.453-3.253-7.627-7.24-7.72-7.36-7.907-7.534l-.347-.32Zm25.413,32.908a7.174,7.174,0,0,1,4.133,3.707,4.448,4.448,0,0,1,.613,2.627,6.3,6.3,0,0,1-1.013,4.147,7.078,7.078,0,0,1-11.92,0,6.5,6.5,0,0,1-1.053-3.827,6.361,6.361,0,0,1,2.093-4.987A7.031,7.031,0,0,1,119.933-442.905Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Burst",
    transform: "translate(169 1197)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Burst")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurstLogo);
export default __webpack_public_path__ + "static/media/burst_logo.ea3d2371e772be156fc399c77232b018.svg";
export { ForwardRef as ReactComponent };